import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import translations from './translations';
import { FormattedMessage } from 'react-intl';

const StepSuccess = ({ onClick }) => (
  <>
    <Typography variant="body2">
      <FormattedMessage {...translations.formStep.success.description} />
    </Typography>
    <Grid container justify="flex-end">
      <Button onClick={onClick} variant="contained" color="primary">
        <FormattedMessage {...translations.formActions.finish} />
      </Button>
    </Grid>
  </>
);

StepSuccess.propTypes = {
  onClick: PropTypes.func,
};

StepSuccess.defaultProps = {
  onClick: undefined,
};

export default StepSuccess;
